import { useState } from 'react';
import type { FaqItem } from '@/types/content';

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
              >
                <span className="flex items-start gap-3 text-sm font-medium text-foreground-900 md:text-base">
                  <span className="font-display mt-0.5 text-primary-500">Q</span>
                  {item.q}
                </span>
                <i
                  className={`shrink-0 text-lg text-foreground-400 transition-transform duration-300 ${
                    isOpen ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                  aria-hidden="true"
                />
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 pb-5 md:px-6">
                <p className="flex gap-3 text-sm leading-7 text-foreground-600">
                  <span className="font-display shrink-0 text-accent-600">A</span>
                  <span>{item.a}</span>
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}